module.exports = __webpack_public_path__ + "img/1.6.3-1.294324fa.jpg";